<template>
    <div>
        <div v-if="stamps.length > 0" class="table">
            <div class="row">
                <div class="cell"><a href="" class="point-up">Award<span class="fa fa-angles-down"></span></a></div>
                <div class="cell"><a href="" class="point-down">Stamps Used</a></div>
                <div class="cell align-right"><a href="" class="point-down">Stamped</a></div>
            </div>
            <div v-for="stamp in stamps" :key="`ledger-${ stamp.id }`" class="row">
                <div class="cell"><ledger-item-description :stamp="stamp"></ledger-item-description></div>
                <div class="cell"><ledger-item-value :stamp="stamp"></ledger-item-value></div>
                <div class="cell align-right"><relative-date :date="stamp.created_at"></relative-date></div>
            </div>

        </div>

        <div v-if="stamps.length === 0" class="table">
            <nothing-here></nothing-here>
        </div>
    </div>
</template>

<script>

export default {

    props: [ 'stamps' ],

};

</script>



// WEBPACK FOOTER //
// resources/js/components/passport/LedgerItems.vue